import { IonText } from '@ionic/react';
import { IPersonalTime, PERSONAL_TIME_LABELS } from '../model/ICheckin';
import { MouseEvent } from 'react';

export interface IPersonalTimeToggleProps {
    time: IPersonalTime;
    selected: boolean;
    disabled: boolean;
    onClick: () => Promise<void>;
}

export const PersonalTimeToggle: React.FC<IPersonalTimeToggleProps> = ({ time, selected, disabled, onClick }) => {

    // e.g. "/assets/images/personal-time/person-2-inactive.svg"
    const imageUrl = `/assets/images/personal-time/person-${time}-${selected ? 'active' : 'inactive'}.svg`;

    const label = PERSONAL_TIME_LABELS[time];

    const handleClick = async (e: MouseEvent) => {
        e.stopPropagation();
        await onClick();
    };

    return (
        <div
            onClick={handleClick}
            data-id={`personal-time-${time}`}
            data-type={`${selected ? 'active' : 'inactive'}`}
            style={{display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer'}}
        >
            <div style={{position: 'relative', opacity: disabled ? 0.5 : 1}}>
                <img src={imageUrl} alt="" />
            </div>
            <IonText color="medium">
                <small><b>{label}</b></small>
            </IonText>
        </div>
    );
};
